export enum FedopsInteractions {
  UPDATE_STYLE = 'update-style-settings-interaction',
  SET_CURRENCIES = 'set-currencies-interaction',
  GET_CURRENCIES = 'get-currencies-interaction',
  GET_AVAILABLE_CURRENCIES = 'get-available-currencies-interaction',
}
